import { globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import Basket from '@clientWebModules/basket';
import { addCss, removeCss } from '@shared/easyfy.utils';
import { isDesktop, isMobile } from '@clientShared/utils';
import { GetLoginFlyout } from '@clientWebServices/header.service';
import { BreadCrumb } from '@clientWebModules/breadcrumb';
import Menu from '@clientWebModules/menu';
import CountrySelector from '@clientWebModules/countryselector';

@invoke
export default class Header {
  static Instance: Header;
  private header: HTMLElement = document.querySelector('header');
  private mainSection = document.querySelector('main');
  private sticky: number = isMobile() ? 0 : 35;
  private menuItemsWithChildren = document.querySelectorAll('[data-container="categories-section"] .menu-item.level-1.has-children') as NodeListOf<HTMLElement>;
  private menuItems = document.querySelectorAll('.menu-item.level-1') as NodeListOf<HTMLElement>;
  private timer: any;
  private isArrowNeededChecked: boolean = false;
  private headerHeight: number = 0;

  constructor() {
    Header.Instance = this;
    Basket.getBasket();
  }

  onInit() {
    Menu;
    BreadCrumb;
    CountrySelector;

    globalEvent({
      type: 'click',
      events: [
        {
          action: 'toggle-login-flyout',
          callback: this.toggleLoginFlyout,
        },
      ],
    });

    document.addEventListener('scroll', this.onScroll.bind(this));
    document.addEventListener('readystatechange', () => {
      this.openLoginFlyoutForLoginRequest();
    });

    if (isDesktop()) {
      this.menuItemsWithChildren.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          this.timer = setTimeout(() => addCss(this.mainSection, 'menu-overlay'), 400);
        });
      });

      this.menuItemsWithChildren.forEach((item) => {
        item.addEventListener('mouseleave', () => {
          removeCss(this.mainSection, 'menu-overlay');
          clearTimeout(this.timer);
        });
      });
    }
  }

  onScroll() {
    if (this.headerHeight === 0) {
      this.headerHeight = this.header.offsetHeight;
      document.body.style.setProperty('--header-height', `${this.headerHeight}px`);
    }
    window.scrollY > this.sticky ? this.header.classList.add('is-sticky') : this.header.classList.remove('is-sticky');
    window.scrollY > this.sticky ? document.body.classList.add('header-sticky') : document.body.classList.remove('header-sticky');

    if (this.header.classList.contains('is-sticky') && !this.isArrowNeededChecked) {
      if (this.isArrowNeeded()) {
        this.addArrow();
      }
    }
  }

  addArrow() {
    const navArrow = document.querySelector('[data-scroll-direction="right"]');
    navArrow?.classList?.add('visible');
  }

  isArrowNeeded(): boolean {
    this.isArrowNeededChecked = true;
    const navList = document.querySelector('[data-container="nav-list"]') as HTMLElement;
    let totalWidthOfItemEls = 0;
    this.menuItems?.forEach((menuItem) => {
      const itemEl = menuItem;
      totalWidthOfItemEls += itemEl.offsetWidth;
    });

    if (totalWidthOfItemEls > navList?.offsetWidth) {
      return true;
    }

    return false;
  }

  toggleLoginFlyout = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const element: HTMLElement = e.target;

    this.closeOpenModals();

    await GetLoginFlyout()
      .then((response) => {
        if (response.data?.partialHtml && element) {
          document.body.insertAdjacentHTML('beforeend', response.data.partialHtml);
          addCss(document.body, 'noof');
          this.removeFlyoutEvents(element);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  closeOpenModals = () => {
    const openModals = document.querySelectorAll('[data-toggle-open]');

    openModals?.forEach((modal) => {
      (modal.querySelector('[data-event="toggle"]') as HTMLElement)?.click();
    });
  };

  removeFlyoutEvents = (element: HTMLElement) => {
    element.removeAttribute('data-action');
    element.dataset.event = 'toggle';
    element.dataset.overlay = '';
    element.dataset.target = isMobile() ? 'main-menu;login-flyout' : 'login-flyout';
  };

  openLoginFlyoutForLoginRequest = () => {
    if (this.isLoginRequest()) {
      this.invokeOpenLoginFlyout();
    }
  };

  isLoginRequest = () => {
    return window.location.href.indexOf('#login') > -1;
  };

  invokeOpenLoginFlyout = () => {
    const loginButton = document.querySelector('[data-action="toggle-login-flyout"]') as HTMLElement;
    loginButton?.click();
  };
}
